"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gradeResultValidations = exports.messages = exports.isALevelGrade = exports.isBMATGrade = exports.isSACEGrade = exports.isUOAGrade = exports.isACEGrade = exports.isVCEGrade = exports.isCIEGrade = exports.computeMaximumGPA = exports.schoolGPAMaximumByRegion = exports.alevelGrades = exports.bmatGrades = exports.saceGrades = exports.uoaGrades = exports.aceGrades = exports.vceGrades = exports.cieGrades = void 0;
const gradeResultType_1 = __importDefault(require("../constants/gradeResultType"));
const gradeResultValueType_1 = __importDefault(require("../constants/gradeResultValueType"));
const common_1 = require("./common");
// Allowed grades for curriculums.
exports.cieGrades = ['A*', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'U'];
exports.vceGrades = ['UG', 'E', 'E+', 'D', 'D+', 'C', 'C+', 'B', 'B+', 'A', 'A+'];
exports.aceGrades = ['A', 'B', 'C', 'D', 'E'];
exports.uoaGrades = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-'];
exports.saceGrades = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'E+', 'E', 'E-'];
exports.bmatGrades = ['1', '2', '3', '4', '5', 'A', 'B', 'C', 'D', 'E'];
exports.alevelGrades = ['A*', 'A', 'B', 'C', 'D', 'E', 'U'];
exports.schoolGPAMaximumByRegion = {
    [gradeResultValueType_1.default[gradeResultType_1.default.GPA_REGION].US]: 4,
    [gradeResultValueType_1.default[gradeResultType_1.default.GPA_REGION].RUSSIA]: 5,
    [gradeResultValueType_1.default[gradeResultType_1.default.GPA_REGION].JAPAN]: 5,
    [gradeResultValueType_1.default[gradeResultType_1.default.GPA_REGION].BRAZIL]: 10,
};
function computeMaximumGPA(context) {
    const region = context === null || context === void 0 ? void 0 : context.data.find((item) => item.type === gradeResultType_1.default.GPA_REGION);
    return ((region === null || region === void 0 ? void 0 : region.value) && exports.schoolGPAMaximumByRegion[region === null || region === void 0 ? void 0 : region.value]) || 4;
}
exports.computeMaximumGPA = computeMaximumGPA;
// Check if input is a valid CIE grade.
function isCIEGrade(value) {
    return exports.cieGrades.includes(value);
}
exports.isCIEGrade = isCIEGrade;
// Check if input is a valid VCE grade.
function isVCEGrade(value) {
    return exports.vceGrades.includes(value);
}
exports.isVCEGrade = isVCEGrade;
// Check if input is a valid ACE grade.
function isACEGrade(value) {
    return exports.aceGrades.includes(value);
}
exports.isACEGrade = isACEGrade;
// Check if input is a valid UOA grade.
function isUOAGrade(value) {
    return exports.uoaGrades.includes(value);
}
exports.isUOAGrade = isUOAGrade;
// Check if input is a valid SACE grade.
function isSACEGrade(value) {
    return exports.saceGrades.includes(value);
}
exports.isSACEGrade = isSACEGrade;
// Check if input is a valid BMAT grade.
function isBMATGrade(value) {
    return exports.bmatGrades.includes(value);
}
exports.isBMATGrade = isBMATGrade;
function isALevelGrade(value) {
    const reg = /^((A\*)*|[A-E]*|U)*$/g;
    return value.match(reg);
}
exports.isALevelGrade = isALevelGrade;
// Validation messages.
exports.messages = {
    gradeValidationMessage: (grades) => {
        return `Result must be one of: ${grades.join(', ')}.`;
    },
};
exports.gradeResultValidations = {
    [gradeResultType_1.default.IB_PREDICTED_GRADE]: {
        validator: (value) => common_1.isInRange(value, 0, 7),
        validationMessage: common_1.messages.rangeValidationMessage(0, 7),
    },
    [gradeResultType_1.default.IB_ACHIEVED_GRADE]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 7) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 7),
    },
    [gradeResultType_1.default.IB_TOK_PREDICTED_GRADE]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.IB_TOK_PREDICTED_GRADE]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.IB_TOK_ACHIEVED_GRADE]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.IB_TOK_ACHIEVED_GRADE]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.IB_EE_PREDICTED_GRADE]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.IB_EE_PREDICTED_GRADE]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.IB_EE_ACHIEVED_GRADE]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.IB_EE_ACHIEVED_GRADE]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.IB_CAS_PREDICTED_GRADE]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.IB_CAS_PREDICTED_GRADE]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.IB_CAS_ACHIEVED_GRADE]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.IB_CAS_ACHIEVED_GRADE]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.CIE_SCHOOL_EXAM_PERCENTAGE]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.CIE_SCHOOL_EXAM_GRADE]: {
        validator: (value) => isCIEGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.cieGrades),
    },
    [gradeResultType_1.default.CIE_FINAL_EXAM_PERCENTAGE]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.CIE_FINAL_EXAM_GRADE]: {
        validator: (value) => (value ? isCIEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.cieGrades),
    },
    [gradeResultType_1.default.CIE_AWARDS]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.CIE_AWARDS]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.CIE_AGGREGATE_SCORE]: {
        validator: (value) => (value ? isALevelGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.alevelGrades),
    },
    [gradeResultType_1.default.NCEA_NOT_ACHIEVED_CREDITS]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NCEA_ACHIEVED_CREDITS]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NCEA_MERIT_CREDITS]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NCEA_EXCELLENCE_CREDITS]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NCEA_NOT_ACHIEVED_CREDITS_EXTERNAL]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NCEA_ACHIEVED_CREDITS_EXTERNAL]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NCEA_MERIT_CREDITS_EXTERNAL]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NCEA_EXCELLENCE_CREDITS_EXTERNAL]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NCEA_SUBJECT_ENDORSEMENT]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.NCEA_SUBJECT_ENDORSEMENT]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.HSC_EXAMINATION_MARK]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HSC_ASSESSMENT_MARK]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HSC_MARK]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HSC_PERFORMANCE_BAND]: {
        validator: (value) => common_1.isInRange(value, 0, 6),
        validationMessage: common_1.messages.rangeValidationMessage(0, 6),
    },
    [gradeResultType_1.default.VCE_GA1]: {
        validator: (value) => isVCEGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.vceGrades),
    },
    [gradeResultType_1.default.VCE_GA2]: {
        validator: (value) => isVCEGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.vceGrades),
    },
    [gradeResultType_1.default.VCE_GA3]: {
        validator: (value) => isVCEGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.vceGrades),
    },
    [gradeResultType_1.default.VCE_STUDY_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 50),
        validationMessage: common_1.messages.rangeValidationMessage(0, 50),
    },
    [gradeResultType_1.default.VCE_SCALED_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 60),
        validationMessage: common_1.messages.rangeValidationMessage(0, 60),
    },
    [gradeResultType_1.default.NZQA_AWARDS]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.NZQA_AWARDS]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.NZQA_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 40),
        validationMessage: common_1.messages.rangeValidationMessage(0, 40),
    },
    [gradeResultType_1.default.SAT_REASONING_READING_WRITING]: {
        validator: (value) => common_1.isInRange(value, 0, 800),
        validationMessage: common_1.messages.rangeValidationMessage(0, 800),
    },
    [gradeResultType_1.default.SAT_REASONING_MATH]: {
        validator: (value) => common_1.isInRange(value, 0, 800),
        validationMessage: common_1.messages.rangeValidationMessage(0, 800),
    },
    [gradeResultType_1.default.SAT_REASONING_ESSAY]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 24) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 24),
    },
    [gradeResultType_1.default.SAT_REASONING_OVERALL_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 1600),
        validationMessage: common_1.messages.rangeValidationMessage(0, 1600),
    },
    [gradeResultType_1.default.ACT_MATH]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.ACT_SCIENCE]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.ACT_READING]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.ACT_ENGLISH]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.ACT_WRITING]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 12) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 12),
    },
    [gradeResultType_1.default.ACT_OVERALL_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.AP_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 5),
        validationMessage: common_1.messages.rangeValidationMessage(0, 5),
    },
    [gradeResultType_1.default.SAT_SUBJECT_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 800),
        validationMessage: common_1.messages.rangeValidationMessage(0, 800),
    },
    [gradeResultType_1.default.IB_EE_TOK]: {
        validator: (value) => common_1.isInRange(value, 0, 3),
        validationMessage: common_1.messages.rangeValidationMessage(0, 3),
    },
    [gradeResultType_1.default.IB_TOTAL_POINTS]: {
        validator: (value) => common_1.isInRange(value, 0, 45),
        validationMessage: common_1.messages.rangeValidationMessage(0, 45),
    },
    [gradeResultType_1.default.IB_RESULTS]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.IB_RESULTS]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.HSC_ATAR]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.VCE_AGGREGATE]: {
        validator: (value) => common_1.isInRange(value, 0, 252),
        validationMessage: common_1.messages.rangeValidationMessage(0, 252),
    },
    [gradeResultType_1.default.VCE_ATAR]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.NZQA_OVERALL_AWARDS]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.NZQA_OVERALL_AWARDS]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.NCEA_LEVEL_1_ENDORSEMENT]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.NCEA_LEVEL_1_ENDORSEMENT]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.NCEA_LEVEL_2_ENDORSEMENT]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.NCEA_LEVEL_2_ENDORSEMENT]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.NCEA_LEVEL_3_ENDORSEMENT]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.NCEA_LEVEL_3_ENDORSEMENT]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.NCEA_TOTAL_CREDITS]: {
        validator: (value) => (value ? common_1.isNumber(value) : true),
        validationMessage: common_1.messages.numericValidationMessage,
    },
    [gradeResultType_1.default.NCEA_TOTAL_CREDITS_EXTERNAL]: {
        validator: (value) => (value ? common_1.isNumber(value) : true),
        validationMessage: common_1.messages.numericValidationMessage,
    },
    [gradeResultType_1.default.IELTS_TEST_TYPE]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.IELTS_TEST_TYPE]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.IELTS_LISTENING]: {
        validator: (value) => common_1.isInRange(value, 1, 9),
        validationMessage: common_1.messages.rangeValidationMessage(1, 9),
    },
    [gradeResultType_1.default.IELTS_READING]: {
        validator: (value) => common_1.isInRange(value, 1, 9),
        validationMessage: common_1.messages.rangeValidationMessage(1, 9),
    },
    [gradeResultType_1.default.IELTS_WRITING]: {
        validator: (value) => common_1.isInRange(value, 1, 9),
        validationMessage: common_1.messages.rangeValidationMessage(1, 9),
    },
    [gradeResultType_1.default.IELTS_SPEAKING]: {
        validator: (value) => common_1.isInRange(value, 1, 9),
        validationMessage: common_1.messages.rangeValidationMessage(1, 9),
    },
    [gradeResultType_1.default.IELTS_OVERALL]: {
        validator: (value) => common_1.isInRange(value, 1, 9),
        validationMessage: common_1.messages.rangeValidationMessage(1, 9),
    },
    [gradeResultType_1.default.TOEFL_LISTENING]: {
        validator: (value) => common_1.isInRange(value, 0, 30),
        validationMessage: common_1.messages.rangeValidationMessage(0, 30),
    },
    [gradeResultType_1.default.TOEFL_READING]: {
        validator: (value) => common_1.isInRange(value, 0, 30),
        validationMessage: common_1.messages.rangeValidationMessage(0, 30),
    },
    [gradeResultType_1.default.TOEFL_WRITING]: {
        validator: (value) => common_1.isInRange(value, 0, 30),
        validationMessage: common_1.messages.rangeValidationMessage(0, 30),
    },
    [gradeResultType_1.default.TOEFL_SPEAKING]: {
        validator: (value) => common_1.isInRange(value, 0, 30),
        validationMessage: common_1.messages.rangeValidationMessage(0, 30),
    },
    [gradeResultType_1.default.TOEFL_OVERALL]: {
        validator: (value) => common_1.isInRange(value, 0, 120),
        validationMessage: common_1.messages.rangeValidationMessage(0, 120),
    },
    [gradeResultType_1.default.UCAT_VR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.UCAT_DM_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.UCAT_QR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.UCAT_AR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.UCAT_TOTAL_COGNITIVE_SUBTEST_SCORE]: {
        validator: (value) => common_1.isInRange(value, 1200, 3600),
        validationMessage: common_1.messages.rangeValidationMessage(1200, 3600),
    },
    [gradeResultType_1.default.UCAT_SJT_SCORE]: {
        validator: (value) => common_1.isInRange(value, 1, 4),
        validationMessage: common_1.messages.rangeValidationMessage(1, 4),
    },
    [gradeResultType_1.default.UCAT_PERCENTILE]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 99) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 99),
    },
    [gradeResultType_1.default.GAMSAT_SECTION_I_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.GAMSAT_SECTION_II_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.GAMSAT_SECTION_III_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.GAMSAT_OVERALL_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.GAMSAT_PERCENTILE]: {
        validator: (value) => common_1.isInRange(value, 0, 99),
        validationMessage: common_1.messages.rangeValidationMessage(0, 99),
    },
    [gradeResultType_1.default.QCE_IA_1_NUMERICAL_SCORE]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.QCE_IA_1_GRADE]: {
        validator: (value) => (value ? isACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.aceGrades),
    },
    [gradeResultType_1.default.QCE_IA_2_NUMERICAL_SCORE]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.QCE_IA_2_GRADE]: {
        validator: (value) => (value ? isACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.aceGrades),
    },
    [gradeResultType_1.default.QCE_IA_3_NUMERICAL_SCORE]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.QCE_IA_3_GRADE]: {
        validator: (value) => (value ? isACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.aceGrades),
    },
    [gradeResultType_1.default.QCE_EA_1_NUMERICAL_SCORE]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.QCE_EA_1_GRADE]: {
        validator: (value) => (value ? isACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.aceGrades),
    },
    [gradeResultType_1.default.QCE_OVERALL_NUMERICAL_SCORE]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.QCE_OVERALL_GRADE]: {
        validator: (value) => (value ? isACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.aceGrades),
    },
    [gradeResultType_1.default.WACE_SCHOOL_MARK_NUMERICAL]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.WACE_SCHOOL_MARK_GRADE]: {
        validator: (value) => (value ? isACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.aceGrades),
    },
    [gradeResultType_1.default.WACE_EXAM_MARK_NUMERICAL]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.WACE_EXAM_GRADE]: {
        validator: (value) => (value ? isACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.aceGrades),
    },
    [gradeResultType_1.default.WACE_COMBINED_SCORE]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 100) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.SACE_IA_GRADE]: {
        validator: (value) => (value ? isSACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.saceGrades),
    },
    [gradeResultType_1.default.SACE_EA_GRADE]: {
        validator: (value) => (value ? isSACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.saceGrades),
    },
    [gradeResultType_1.default.SACE_FINAL_GRADE]: {
        validator: (value) => (value ? isSACEGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.saceGrades),
    },
    [gradeResultType_1.default.CELS191_PROGRESS_TEST_MARK]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.CELS191_FINAL_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.CHEM191_PROGRESS_TEST_MARK]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.CHEM191_FINAL_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.PHSI191_PROGRESS_TEST_MARK]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.PHSI191_FINAL_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.BIOC192_PROGRESS_TEST_MARK]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.BIOC192_FINAL_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.HUBS191_PROGRESS_TEST_1_MARK]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.HUBS191_PROGRESS_TEST_2_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.HUBS191_FINAL_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.HUBS192_PROGRESS_TEST_1_MARK]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.HUBS192_PROGRESS_TEST_2_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.HUBS192_FINAL_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.POPH192_PROGRESS_TEST_1_MARK]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.POPH192_PROGRESS_TEST_2_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.POPH192_FINAL_MARK]: {
        validator: (value) => (value ? common_1.isPercentage(value) : true),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.OPTIONAL_8TH_PAPER_FINAL_MARK]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.ISAT_CR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.ISAT_QR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.ISAT_TOTAL_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.ISAT_PERCENTILE]: {
        validator: (value) => common_1.isInRange(value, 0, 99),
        validationMessage: common_1.messages.rangeValidationMessage(0, 99),
    },
    [gradeResultType_1.default.BMAT_SECTION_1]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.BMAT_SECTION_2]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.BMAT_SECTION_3]: {
        validator: (value) => isBMATGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.bmatGrades),
    },
    [gradeResultType_1.default.BIOSCI107_TEST_GRADE]: {
        validator: (value) => isUOAGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.BIOSCI107_FINAL_GRADE]: {
        validator: (value) => (value ? isUOAGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.CHEM110_TEST_GRADE]: {
        validator: (value) => isUOAGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.CHEM110_FINAL_GRADE]: {
        validator: (value) => (value ? isUOAGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.POPLHLTH111_TEST_GRADE]: {
        validator: (value) => isUOAGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.POPLHLTH111_FINAL_GRADE]: {
        validator: (value) => (value ? isUOAGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.MEDSCI142_TEST_1_GRADE]: {
        validator: (value) => isUOAGrade(value),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.MEDSCI142_TEST_2_GRADE]: {
        validator: (value) => (value ? isUOAGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.MEDSCI142_FINAL_GRADE]: {
        validator: (value) => (value ? isUOAGrade(value) : true),
        validationMessage: exports.messages.gradeValidationMessage(exports.uoaGrades),
    },
    [gradeResultType_1.default.ATAR]: {
        validator: (value) => common_1.isInRange(value, 0, 99.95),
        validationMessage: common_1.messages.rangeValidationMessage(0, 99.95),
    },
    [gradeResultType_1.default.AKL_CCP_OVERALL_GPA]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.OTAGO_P_AVG_BEST_7_AVERAGE]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.SCHOOL_GPA]: {
        validator: (value, context) => common_1.isInRange(value, 0, computeMaximumGPA(context)),
        validationMessage: (context) => common_1.messages.rangeValidationMessage(0, computeMaximumGPA(context)),
    },
    [gradeResultType_1.default.GPA_REGION]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.GPA_REGION]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.GPA_YEAR]: {
        validator: (value) => common_1.isInEnum(value, gradeResultValueType_1.default[gradeResultType_1.default.GPA_YEAR]),
        validationMessage: common_1.messages.enumValidationMessage,
    },
    [gradeResultType_1.default.PRACTICE_SAT_READING_WRITING]: {
        validator: (value) => common_1.isInRange(value, 0, 800),
        validationMessage: common_1.messages.rangeValidationMessage(0, 800),
    },
    [gradeResultType_1.default.PRACTICE_SAT_MATH]: {
        validator: (value) => common_1.isInRange(value, 0, 800),
        validationMessage: common_1.messages.rangeValidationMessage(0, 800),
    },
    [gradeResultType_1.default.PRACTICE_SAT_ESSAY]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 24) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 24),
    },
    [gradeResultType_1.default.PRACTICE_SAT_OVERALL_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 1600),
        validationMessage: common_1.messages.rangeValidationMessage(0, 1600),
    },
    [gradeResultType_1.default.PRACTICE_ACT_MATH]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.PRACTICE_ACT_SCIENCE]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.PRACTICE_ACT_READING]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.PRACTICE_ACT_ENGLISH]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.PRACTICE_ACT_WRITING]: {
        validator: (value) => (value ? common_1.isInRange(value, 0, 12) : true),
        validationMessage: common_1.messages.rangeValidationMessage(0, 12),
    },
    [gradeResultType_1.default.PRACTICE_ACT_OVERALL_SCORE]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.Duolingo]: {
        validator: (value) => common_1.isInRange(value, 10, 160),
        validationMessage: common_1.messages.rangeValidationMessage(10, 160),
    },
    [gradeResultType_1.default.TOEFL_PBT_OVERALL]: {
        validator: (value) => common_1.isInRange(value, 310, 677),
        validationMessage: common_1.messages.rangeValidationMessage(310, 677),
    },
    [gradeResultType_1.default.TSA_SECTION_1]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.SSAT_VERBAL]: {
        validator: (value) => common_1.isInRange(value, 440, 800),
        validationMessage: common_1.messages.rangeValidationMessage(440, 800),
    },
    [gradeResultType_1.default.SSAT_QUANTITATIVE]: {
        validator: (value) => common_1.isInRange(value, 440, 800),
        validationMessage: common_1.messages.rangeValidationMessage(440, 800),
    },
    [gradeResultType_1.default.SSAT_READING]: {
        validator: (value) => common_1.isInRange(value, 440, 800),
        validationMessage: common_1.messages.rangeValidationMessage(440, 800),
    },
    [gradeResultType_1.default.SSAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 1320, 2400),
        validationMessage: common_1.messages.rangeValidationMessage(1320, 2400),
    },
    [gradeResultType_1.default.ISEE_MATH]: {
        validator: (value) => common_1.isInRange(value, 760, 940),
        validationMessage: common_1.messages.rangeValidationMessage(760, 940),
    },
    [gradeResultType_1.default.ISEE_QUANTITATIVE_REASONING]: {
        validator: (value) => common_1.isInRange(value, 760, 940),
        validationMessage: common_1.messages.rangeValidationMessage(760, 940),
    },
    [gradeResultType_1.default.ISEE_READING_COMPREHENSION]: {
        validator: (value) => common_1.isInRange(value, 760, 940),
        validationMessage: common_1.messages.rangeValidationMessage(760, 940),
    },
    [gradeResultType_1.default.ISEE_VERBAL_REASONING]: {
        validator: (value) => common_1.isInRange(value, 760, 940),
        validationMessage: common_1.messages.rangeValidationMessage(760, 940),
    },
    [gradeResultType_1.default.PTE_LISTENING]: {
        validator: (value) => common_1.isInRange(value, 10, 90),
        validationMessage: common_1.messages.rangeValidationMessage(10, 90),
    },
    [gradeResultType_1.default.PTE_SPEAKING]: {
        validator: (value) => common_1.isInRange(value, 10, 90),
        validationMessage: common_1.messages.rangeValidationMessage(10, 90),
    },
    [gradeResultType_1.default.PTE_WRITING]: {
        validator: (value) => common_1.isInRange(value, 10, 90),
        validationMessage: common_1.messages.rangeValidationMessage(10, 90),
    },
    [gradeResultType_1.default.PTE_READING]: {
        validator: (value) => common_1.isInRange(value, 10, 90),
        validationMessage: common_1.messages.rangeValidationMessage(10, 90),
    },
    [gradeResultType_1.default.PTE_OVERALL]: {
        validator: (value) => common_1.isInRange(value, 10, 90),
        validationMessage: common_1.messages.rangeValidationMessage(10, 90),
    },
    [gradeResultType_1.default.GMAT_QUANTITATIVE]: {
        validator: (value) => common_1.isInRange(value, 0, 60),
        validationMessage: common_1.messages.rangeValidationMessage(0, 60),
    },
    [gradeResultType_1.default.GMAT_VERBAL]: {
        validator: (value) => common_1.isInRange(value, 0, 60),
        validationMessage: common_1.messages.rangeValidationMessage(0, 60),
    },
    [gradeResultType_1.default.GMAT_REASONING]: {
        validator: (value) => common_1.isInRange(value, 1, 8),
        validationMessage: common_1.messages.rangeValidationMessage(1, 8),
    },
    [gradeResultType_1.default.GMAT_WRITING]: {
        validator: (value) => common_1.isInRange(value, 0, 6),
        validationMessage: common_1.messages.rangeValidationMessage(0, 6),
    },
    [gradeResultType_1.default.GMAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 200, 800),
        validationMessage: common_1.messages.rangeValidationMessage(200, 800),
    },
    [gradeResultType_1.default.GRE_ANALYTICAL_WRITING]: {
        validator: (value) => common_1.isInRange(value, 0, 6),
        validationMessage: common_1.messages.rangeValidationMessage(0, 6),
    },
    [gradeResultType_1.default.GRE_QUANTITATIVE_REASONING]: {
        validator: (value) => common_1.isInRange(value, 130, 170),
        validationMessage: common_1.messages.rangeValidationMessage(130, 170),
    },
    [gradeResultType_1.default.GRE_VERBAL_REASONING]: {
        validator: (value) => common_1.isInRange(value, 130, 170),
        validationMessage: common_1.messages.rangeValidationMessage(130, 170),
    },
    [gradeResultType_1.default.GRE_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 260, 340),
        validationMessage: common_1.messages.rangeValidationMessage(260, 340),
    },
    [gradeResultType_1.default.LSAT_SCORE]: {
        validator: (value) => common_1.isInRange(value, 120, 180),
        validationMessage: common_1.messages.rangeValidationMessage(120, 180),
    },
    [gradeResultType_1.default.LSAT_PERCENTILE]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.MCAT_BIOLOGICAL_AND_BIOCHEMICAL_FOUNDATIONS]: {
        validator: (value) => common_1.isInRange(value, 118, 132),
        validationMessage: common_1.messages.rangeValidationMessage(118, 132),
    },
    [gradeResultType_1.default.MCAT_CHEMICAL_AND_PHYSICAL_FOUNDATIONS]: {
        validator: (value) => common_1.isInRange(value, 118, 132),
        validationMessage: common_1.messages.rangeValidationMessage(118, 132),
    },
    [gradeResultType_1.default.MCAT_CRITICAL_ANALYSIS_AND_REASONING_SKILLS]: {
        validator: (value) => common_1.isInRange(value, 118, 132),
        validationMessage: common_1.messages.rangeValidationMessage(118, 132),
    },
    [gradeResultType_1.default.MCAT_PHYSIOGILOGICAL_FOUNDATIONS]: {
        validator: (value) => common_1.isInRange(value, 118, 132),
        validationMessage: common_1.messages.rangeValidationMessage(118, 132),
    },
    [gradeResultType_1.default.MCAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 472, 528),
        validationMessage: common_1.messages.rangeValidationMessage(472, 528),
    },
    [gradeResultType_1.default.LNAT_SECTION_A]: {
        validator: (value) => common_1.isInRange(value, 0, 42),
        validationMessage: common_1.messages.rangeValidationMessage(0, 42),
    },
    [gradeResultType_1.default.MAT_Q1]: {
        validator: (value) => common_1.isInRange(value, 0, 40),
        validationMessage: common_1.messages.rangeValidationMessage(0, 40),
    },
    [gradeResultType_1.default.MAT_Q2_Q7]: {
        validator: (value) => common_1.isInRange(value, 0, 60),
        validationMessage: common_1.messages.rangeValidationMessage(0, 60),
    },
    [gradeResultType_1.default.MAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.TMUA_PAPER_1]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.TMUA_PAPER_2]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.TMUA_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.NSAA_SECTION_A]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.NSAA_SECTION_B]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.NSAA_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.ENGAA_SECTION_1A]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.ENGAA_SECTION_1B]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.ENGAA_SECTION_2]: {
        validator: (value) => common_1.isInRange(value, 0, 9),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9),
    },
    [gradeResultType_1.default.STEP_MATH_II]: {
        validator: (value) => common_1.isInRange(value, 0, 120),
        validationMessage: common_1.messages.rangeValidationMessage(0, 120),
    },
    [gradeResultType_1.default.STEP_MATH_III]: {
        validator: (value) => common_1.isInRange(value, 0, 120),
        validationMessage: common_1.messages.rangeValidationMessage(0, 120),
    },
    [gradeResultType_1.default.HPAT_LOGICAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HPAT_INTERPERSONAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HPAT_NON_VERBAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HPAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 300),
        validationMessage: common_1.messages.rangeValidationMessage(0, 300),
    },
    [gradeResultType_1.default.PAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.ELAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 60),
        validationMessage: common_1.messages.rangeValidationMessage(0, 60),
    },
    [gradeResultType_1.default.HAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.CAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.OLAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.MLAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.PHIL_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.IMAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 90),
        validationMessage: common_1.messages.rangeValidationMessage(0, 90),
    },
    [gradeResultType_1.default.BOCCONI_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 50),
        validationMessage: common_1.messages.rangeValidationMessage(0, 50),
    },
    [gradeResultType_1.default.TUMAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 80),
        validationMessage: common_1.messages.rangeValidationMessage(0, 80),
    },
    [gradeResultType_1.default.PSAT_READING_WRITING]: {
        validator: (value) => common_1.isInRange(value, 160, 760),
        validationMessage: common_1.messages.rangeValidationMessage(160, 760),
    },
    [gradeResultType_1.default.PSAT_MATH]: {
        validator: (value) => common_1.isInRange(value, 160, 760),
        validationMessage: common_1.messages.rangeValidationMessage(160, 760),
    },
    [gradeResultType_1.default.PSAT_OVERALL_SCORE]: {
        validator: (value) => common_1.isInRange(value, 320, 1520),
        validationMessage: common_1.messages.rangeValidationMessage(320, 1520),
    },
    [gradeResultType_1.default.UK_ISAT_CR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 100, 200),
        validationMessage: common_1.messages.rangeValidationMessage(100, 200),
    },
    [gradeResultType_1.default.UK_ISAT_QR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 100, 200),
        validationMessage: common_1.messages.rangeValidationMessage(100, 200),
    },
    [gradeResultType_1.default.UK_ISAT_TOTAL_SCORE]: {
        validator: (value) => common_1.isInRange(value, 100, 200),
        validationMessage: common_1.messages.rangeValidationMessage(100, 200),
    },
    [gradeResultType_1.default.UK_ISAT_PERCENTILE]: {
        validator: (value) => common_1.isInRange(value, 1, 100),
        validationMessage: common_1.messages.rangeValidationMessage(1, 100),
    },
    [gradeResultType_1.default.UK_ISAT_CR_PERCENTILE]: {
        validator: (value) => common_1.isInRange(value, 1, 100),
        validationMessage: common_1.messages.rangeValidationMessage(1, 100),
    },
    [gradeResultType_1.default.UK_ISAT_QR_PERCENTILE]: {
        validator: (value) => common_1.isInRange(value, 1, 100),
        validationMessage: common_1.messages.rangeValidationMessage(1, 100),
    },
    // below are EU testings
    [gradeResultType_1.default.EU_PCE_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_PCE_COMBINED]: {
        validator: (value) => common_1.isInRange(value, 0, 14),
        validationMessage: common_1.messages.rangeValidationMessage(0, 14),
    },
    [gradeResultType_1.default.EU_PCE_COMBINED_SECONDARY_CERTIFICATE_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 14),
        validationMessage: common_1.messages.rangeValidationMessage(0, 14),
    },
    [gradeResultType_1.default.EU_OMPT_A]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.EU_OMPT_B]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.EU_OMPT_C]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.EU_OMPT_D]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.EU_VWO_PHYSICS]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_VWO_CHEMISTRY]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_VWO_MATH_A]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_VWO_MATH_B]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_VWO_MATH_C]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_VWO_BIOLOGY]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_HUMAT]: {
        validator: (value) => common_1.isInRange(value, 0, 180),
        validationMessage: common_1.messages.rangeValidationMessage(0, 180),
    },
    [gradeResultType_1.default.EU_UCAT_CAMILLUS_VR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.EU_UCAT_CAMILLUS_VR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.EU_UCAT_CAMILLUS_DM_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.EU_UCAT_CAMILLUS_QR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.EU_UCAT_CAMILLUS_AR_SCORE]: {
        validator: (value) => common_1.isInRange(value, 300, 900),
        validationMessage: common_1.messages.rangeValidationMessage(300, 900),
    },
    [gradeResultType_1.default.EU_UCAT_CAMILLUS_SJ_SCORE]: {
        validator: (value) => common_1.isInRange(value, 1, 4),
        validationMessage: common_1.messages.rangeValidationMessage(1, 4),
    },
    [gradeResultType_1.default.EU_UCAT_CAMILLUS_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 1200, 3600),
        validationMessage: common_1.messages.rangeValidationMessage(1200, 3600),
    },
    [gradeResultType_1.default.EU_IE_UNIVERSITY_ADMISSIONS]: {
        validator: (value) => common_1.isInRange(value, 0, 9999999),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9999999),
    },
    [gradeResultType_1.default.EU_ARCHITECTURE_ADMISSIONS]: {
        validator: (value) => common_1.isInRange(value, 0, 9999999),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9999999),
    },
    [gradeResultType_1.default.EU_ETH_ZURICH]: {
        validator: (value) => common_1.isInRange(value, 0, 6),
        validationMessage: common_1.messages.rangeValidationMessage(0, 6),
    },
    [gradeResultType_1.default.EU_EHL_ADMISSIONS]: {
        validator: (value) => common_1.isInRange(value, 0, 9999999),
        validationMessage: common_1.messages.rangeValidationMessage(0, 9999999),
    },
    [gradeResultType_1.default.EU_CCVX_BIOLOGY]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_CCVX_PHYSICS]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_CCVX_CHEMISTRY]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_CCVX_MATH_A]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_CCVX_MATH_B]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_BOCCONI_ONLINE]: {
        validator: (value) => common_1.isInRange(value, 0, 50),
        validationMessage: common_1.messages.rangeValidationMessage(0, 50),
    },
    [gradeResultType_1.default.EU_ENLIGSH_TOLC_I]: {
        validator: (value) => common_1.isInRange(value, 0, 50),
        validationMessage: common_1.messages.rangeValidationMessage(0, 50),
    },
    [gradeResultType_1.default.EU_ENLIGSH_TOLC_E]: {
        validator: (value) => common_1.isInRange(value, 0, 36),
        validationMessage: common_1.messages.rangeValidationMessage(0, 36),
    },
    [gradeResultType_1.default.EU_ENLIGSH_TOLC_F]: {
        validator: (value) => common_1.isInRange(value, 0, 50),
        validationMessage: common_1.messages.rangeValidationMessage(0, 50),
    },
    [gradeResultType_1.default.EU_STUDIENKOLLEG]: {
        validator: (value) => common_1.isPercentage(value),
        validationMessage: common_1.messages.percentageValidationMessage,
    },
    [gradeResultType_1.default.EU_EBAU]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.EU_EBAU_COMBINED]: {
        validator: (value) => common_1.isInRange(value, 0, 14),
        validationMessage: common_1.messages.rangeValidationMessage(0, 14),
    },
    [gradeResultType_1.default.EU_EBAU_COMBINED_SECONDARY_CERTIFICATE_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 14),
        validationMessage: common_1.messages.rangeValidationMessage(0, 14),
    },
    // bellow are extra UK testings
    [gradeResultType_1.default.ARCHAEOLOGY_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.ARCH_ADMIS_ASSESS_total]: {
        validator: (value) => common_1.isInRange(value, 0, 20),
        validationMessage: common_1.messages.rangeValidationMessage(0, 20),
    },
    [gradeResultType_1.default.ARCH_ADMIS_ASSESS_1]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.ARCH_ADMIS_ASSESS_2]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.MOD_MED_LANG_ADMIS_ASSESS_total]: {
        validator: (value) => common_1.isInRange(value, 0, 48),
        validationMessage: common_1.messages.rangeValidationMessage(0, 48),
    },
    [gradeResultType_1.default.MOD_MED_LANG_ADMIS_ASSESS_A]: {
        validator: (value) => common_1.isInRange(value, 0, 32),
        validationMessage: common_1.messages.rangeValidationMessage(0, 32),
    },
    [gradeResultType_1.default.MOD_MED_LANG_ADMIS_ASSESS_B]: {
        validator: (value) => common_1.isInRange(value, 0, 16),
        validationMessage: common_1.messages.rangeValidationMessage(0, 16),
    },
    [gradeResultType_1.default.ENGL_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.GEOG_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HIST_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HIST_ART_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.HIST_SOC_POL_SCI_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.LING_ADMIS_ASSESS_total]: {
        validator: (value) => common_1.isInRange(value, 0, 90),
        validationMessage: common_1.messages.rangeValidationMessage(0, 90),
    },
    [gradeResultType_1.default.LING_ADMIS_ASSESS_1]: {
        validator: (value) => common_1.isInRange(value, 0, 30),
        validationMessage: common_1.messages.rangeValidationMessage(0, 30),
    },
    [gradeResultType_1.default.LING_ADMIS_ASSESS_2]: {
        validator: (value) => common_1.isInRange(value, 0, 30),
        validationMessage: common_1.messages.rangeValidationMessage(0, 30),
    },
    [gradeResultType_1.default.LING_ADMIS_ASSESS_3]: {
        validator: (value) => common_1.isInRange(value, 0, 30),
        validationMessage: common_1.messages.rangeValidationMessage(0, 30),
    },
    [gradeResultType_1.default.MATH_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.MUS_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.PHIL_ADMIS_ASSESS_total]: {
        validator: (value) => common_1.isInRange(value, 0, 118),
        validationMessage: common_1.messages.rangeValidationMessage(0, 118),
    },
    [gradeResultType_1.default.PHIL_ADMIS_ASSESS_1]: {
        validator: (value) => common_1.isInRange(value, 0, 18),
        validationMessage: common_1.messages.rangeValidationMessage(0, 18),
    },
    [gradeResultType_1.default.PHIL_ADMIS_ASSESS_2]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.PSYCH_ADMIS_ASSESS]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.AHCAAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 100),
        validationMessage: common_1.messages.rangeValidationMessage(0, 100),
    },
    [gradeResultType_1.default.BSMAT_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 120),
        validationMessage: common_1.messages.rangeValidationMessage(0, 120),
    },
    [gradeResultType_1.default.ENEM_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 1000),
        validationMessage: common_1.messages.rangeValidationMessage(0, 1000),
    },
    [gradeResultType_1.default.ENEM_LANGUAGE]: {
        validator: (value) => common_1.isInRange(value, 0, 200),
        validationMessage: common_1.messages.rangeValidationMessage(0, 200),
    },
    [gradeResultType_1.default.ENEM_MATHEMATICS]: {
        validator: (value) => common_1.isInRange(value, 0, 200),
        validationMessage: common_1.messages.rangeValidationMessage(0, 200),
    },
    [gradeResultType_1.default.ENEM_NATURAL_SCIENCES]: {
        validator: (value) => common_1.isInRange(value, 0, 200),
        validationMessage: common_1.messages.rangeValidationMessage(0, 200),
    },
    [gradeResultType_1.default.ENEM_WRITING]: {
        validator: (value) => common_1.isInRange(value, 0, 200),
        validationMessage: common_1.messages.rangeValidationMessage(0, 200),
    },
    [gradeResultType_1.default.ENEM_HUMANITIES]: {
        validator: (value) => common_1.isInRange(value, 0, 200),
        validationMessage: common_1.messages.rangeValidationMessage(0, 200),
    },
    [gradeResultType_1.default.ARCHITECTURE_TIL_TEST_SECTION_1]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.ARCHITECTURE_TIL_TEST_SECTION_2]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.ARCHITECTURE_TIL_TEST_SECTION_3]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.ARCHITECTURE_TIL_TEST_SECTION_4]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.ARCHITECTURE_TIL_TEST_SECTION_5]: {
        validator: (value) => common_1.isInRange(value, 0, 10),
        validationMessage: common_1.messages.rangeValidationMessage(0, 10),
    },
    [gradeResultType_1.default.ARCHITECTURE_TIL_TEST_TOTAL]: {
        validator: (value) => common_1.isInRange(value, 0, 50),
        validationMessage: common_1.messages.rangeValidationMessage(0, 50),
    },
};
//# sourceMappingURL=grade.js.map